<template>
  <div>
    <v-dialog ref="dialog" v-model="menu" width="290px">
      <template v-slot:activator="{ on }">
        <div v-on="on">
          <slot v-bind="{ computedDate: computedDateFormatted }"></slot>
        </div>
      </template>
      <v-date-picker v-model="date" scrollable @input="onInput" v-bind="$props">
      </v-date-picker>
    </v-dialog>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    value: {
      //
    },
    min: {
      //
    },
    max: {
      //
    },
    allowedDates: {
      //
    },
    format: {
      default: 'DD/MM/YYYY'
    }
  },
  data() {
    return {
      date: this.value,
      menu: false
    }
  },
  computed: {
    computedDateFormatted() {
      if (!this.date) return null
      return moment(this.date).format(this.format)
    }
  },
  methods: {
    onInput(date) {
      this.menu = false
      this.$emit('input', date)
    }
  }
}
</script>

<style lang="scss" scoped></style>
